export enum SectionType {
    text = 'text',
    image = 'image',
    button = 'button',
}

export interface Section {
    id: number;
    type: SectionType;
    title: string;
    visible: boolean;
    y: number;
}
